export default "__VITE_ASSET__ea486222__"